export default {};
//export const API_URL = "http://localhost:3000";
export const API_URL = "https://my-json-project.herokuapp.com/";

export const API_URL_HERO = "https://uu8kbn0tfb.execute-api.ap-southeast-1.amazonaws.com/staging/admin-dashboard";
//"https://uu8kbn0tfb.execute-api.ap-southeast-1.amazonaws.com/staging/admin-dashboard"
//"https://dvek2bb3jc.execute-api.ap-southeast-1.amazonaws.com/production/admin-dashboard"

//export const API_URL_HERO ="https://2oy9ea92r2.execute-api.ap-southeast-1.amazonaws.com/dev/admin-dashboard";
//export const API_URL = "http://developmentkotakmakan.ap-southeast-1.elasticbeanstalk.com/api/v1/";
export const ROW_PER_PAGE = 10;
export const NUMBER_OF_PAGES = 10;
export const VUE_APP_URL = "https://uu8kbn0tfb.execute-api.ap-southeast-1.amazonaws.com/staging/admin-dashboard";
//"https://uu8kbn0tfb.execute-api.ap-southeast-1.amazonaws.com/staging/management/v1/";
//"https://uu8kbn0tfb.execute-api.ap-southeast-1.amazonaws.com/staging/admin-dashboard"